import React, { useContext } from 'react';
import { MapContext } from 'contexts/MapContext';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    borderRadius: '20px',
    margin: '1vh 1vw',
    cursor: 'pointer',
    color: '#4D7343',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: '17px',
    letterSpacing: '0.25px',
    textAlign: 'left',
  },
});

const primaryTypes = {
  'HikeWalk': 'Hiking/Walking Trail',
  'Multi-use': 'Multi-use Trail',
  'Motorized Trail': 'Motorized Trail',
  'MntnBike': 'Mountain Biking Trail',
  'Snowmobile': 'Snowmobiling Trail',
  'Equestrian': 'Equestrian Trail' ,
  'Cross-country Ski Trail': 'Cross-country Skiing',
  'HuntFishAccess': 'Hunting/Fishing Access Trail',
};

export default function NearbyTrailLink({ attributes }) {
  const classes = useStyles();
  const { mapView, setSidebarSelection } = useContext(MapContext);

  const handleOnClick = async () => {
    const { filterMapDataForTrailSelected, getAllTrailFeaturesByTrailId, getAllNearbyTrails } = await import('data/map');

    const trailId = attributes.PRIMARY_TRAIL_ID;
    const features = await getAllTrailFeaturesByTrailId(trailId, mapView.spatialReference);
    const nearbyFeatures = await getAllNearbyTrails(features[0].geometry, trailId);
    setSidebarSelection(['Trail', attributes, nearbyFeatures, features[0]]);
    await filterMapDataForTrailSelected(features);

    mapView.when(function(){
      mapView.goTo({
        target: features[0], // Graphic object
        zoom: 11
      });
    });  
  };


  return (
    <li className={classes.root} onClick={handleOnClick}>
      {attributes.PRIMARY_NAME}
    </li>
  );
}
